import React from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import useTranslation from './useTranslation';
import LocalIcon from './LocalIcon';
import { getOptimizedPoiImage } from '../utils/imageUtils';

const TinyPoiCardList = ({ 
  poi, 
  taxonomyData, 
  distance,
  onClick // Prop opzionale per la chiusura del pannello
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (onClick) {
      onClick(); // Questo in realtà è handleClose
      setTimeout(() => {
        navigate(`/poi/${poi.nid[0].value}`);
      }, 300);
    }
  };

  // Estrai l'URL dell'immagine con fallback
  const imageUrl = getOptimizedPoiImage(poi, 'max_650x650', '/path/to/default/image.jpg');
  // Estrai la categoria del POI
  const categoryId = poi.field_tipologia_poi?.[0]?.target_id;
  const category = taxonomyData[categoryId] || {};

  return (
    <div className="w-100 p-0"> 
      {/* Layout superiore: immagine + (categoria e titolo) */}
      <div className="d-flex gap-3 mb-2">
        {/* Immagine tonda */}
        <div style={{ width: '70px', height: '70px', flexShrink: 0 }}>
          <img 
            src={imageUrl} 
            className="w-100 h-100 rounded-circle"
            alt={poi.title[0].value}
            loading="lazy"
            decoding="async"
            style={{ objectFit: 'cover' }}
          />
        </div>

        {/* Categoria e titolo */}
        <div className="flex-grow-1">
          {/* Categoria con icona */}
          <div className="d-flex justify-content-start mb-1">
            {category.icon && (
              <img 
                src={category.icon}
                alt={category.title}
                style={{ width: '20px', height: '20px' }}
                className="me-1"
              />
            )}
            <span className="small text-muted">
              {category.title || t('puntoInteresse')}
            </span>
          </div>

          {/* Titolo */}
          <h5 className="card-title fw-bold mb-0">
            {poi.title[0].value}
          </h5>
        </div>
      </div>

      {/* Descrizione breve */}
      {poi.field_descrizione_breve && (
        <div 
          className="tinyDescr card-text" 
          style={{ fontSize: '0.875rem' }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(poi.field_descrizione_breve[0]?.value || '')
          }}
        />
      )}

      {/* Indirizzo */}
      {poi.field_indirizzo && (
        <p className="mb-1 mt-2 text-muted" style={{ fontSize: '0.875rem' }}>
          <LocalIcon icon="location_on" className="align-bottom me-1" style={{ fontSize: '1.1rem' }} />
          {poi.field_indirizzo[0]?.value}
        </p>
      )}

      {/* Distanza e bottone */}
      <div className="d-flex justify-content-between align-items-center mt-2">
        <p className="mb-0" style={{ fontSize: '0.875rem' }}>
          <LocalIcon icon="near_me" className="align-bottom me-1" style={{ fontSize: '1.1rem' }} />
          {t('distanza')}: <span className="fw-bold">{distance}</span>
        </p>
        <button 
          onClick={handleNavigation}
          className="btn border rounded-pill py-1 px-3 d-flex align-items-center shadow-sm"
          style={{ 
            fontSize: '0.875rem',
            backgroundColor: 'var(--color-element)',
            color: 'var(--color-text-primary)'
          }}
        >
          {t('vaiAllaScheda')} 
        </button>
      </div>
    </div>
  );
};

export default TinyPoiCardList;